import type { ScaleTime } from "d3";

/** Horizontal room for one "HH:MM:SS" tick label, including a gap so neighbors do not collide. */
export const MAP_TIME_AXIS_MIN_LABEL_PX = 72;

export function mapTimeAxisTickCount(
  chartWidth: number,
  minLabelPx: number = MAP_TIME_AXIS_MIN_LABEL_PX
): number {
  if (!Number.isFinite(chartWidth) || chartWidth <= 0) return 2;
  return Math.max(2, Math.floor(chartWidth / minLabelPx));
}

/** Keep a subset of ticks so the count stays within what the pixel width can show. */
export function thinAxisTicks<T>(ticks: readonly T[], maxTicks: number): T[] {
  const limit = Math.max(2, maxTicks);
  if (ticks.length <= limit) return ticks.slice();
  const step = Math.ceil(ticks.length / limit);
  const thinned = ticks.filter((_, index) => index % step === 0);
  return thinned.length >= 2 ? thinned : ticks.slice(0, limit);
}

/**
 * Tick instants for the map time-series x-axis.
 * D3's time-scale tick count is only a hint and often lands on a short interval
 * (for example every 5 minutes) that overflows a narrow chart. Ask for a count
 * that fits the width, then drop extras if the scale still overshoots.
 */
export function mapTimeAxisTickValues(
  scale: ScaleTime<number, number>,
  chartWidth: number,
  minLabelPx: number = MAP_TIME_AXIS_MIN_LABEL_PX
): Date[] {
  const maxTicks = mapTimeAxisTickCount(chartWidth, minLabelPx);
  return thinAxisTicks(scale.ticks(maxTicks), maxTicks);
}
